import React from 'react';
import { connect } from 'react-redux';
import { jsx, css } from '@emotion/core';
import { primary_s10_l90 } from '../lib/colors';

const getStyles = (primaryColor, uiVariantInputCheckbox) => css`
  label {
    &::before {
      border: 1px solid ${primary_s10_l90(primaryColor)};
      border-radius: ${uiVariantInputCheckbox === '1'
        ? '5px'
        : uiVariantInputCheckbox === '3'
        ? '50%'
        : 0};
    }

    &::after {
      border-radius: ${uiVariantInputCheckbox === '1'
        ? '2px'
        : uiVariantInputCheckbox === '3'
        ? '50%'
        : 0};
    }
  }
  input[type='radio'] {
    &:checked + label::after {
      background-color: ${primaryColor};
    }
  }
`;

const RadioContainer = props => {
  const cleanProps = { ...props };
  delete cleanProps.primaryColor;
  delete cleanProps.uiVariantInputCheckbox;
  delete cleanProps.dispatch;
  delete cleanProps.children;

  return (
    <div
      css={getStyles(props.primaryColor, props.uiVariantInputCheckbox)}
      {...cleanProps}
      className={`radio ${cleanProps.className}`}
    >
      {props.children}
    </div>
  );
};

const mapStateToProps = state => ({
  primaryColor: state.store.data.loghiTemplate.brandColor,
  uiVariantInputCheckbox: state.store.data.uiVariants.inputCheckbox,
});

export default connect(mapStateToProps)(RadioContainer);
